import { useSelector, useDispatch } from "react-redux";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { updateHelpModal } from "@/store/slices/appStateSlice";
import type { RootState } from "@/store";

export default function HelpModal() {
  const dispatch = useDispatch();
  const isOpen = useSelector((state: RootState) => state.appState.helpModal);

  const handleClose = () => {
    dispatch(updateHelpModal(false));
  };

  const handleCallOffice = () => {
    window.open("tel:01376519743", "_self");
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex gap-4 text-xl items-center font-bold text-gray-900 leading-tight">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
              <svg
                className="fill-blue-800 w-8 h-8"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
              >
                <path d="M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74l0 1.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z" />
              </svg>
            </div>
            Need
              <br />
              Assistance?
          </DialogTitle>
        </DialogHeader>

        <div className="py-4">

          <div className="mb-6">
            <p className="leading-relaxed text-gray-700">
              If you have any questions at all or simply need to clarify any
              items on the job, please call the number below. The office is
              manned 24 hours, 7 days a week, there will always be someone that
              can take your call.
            </p>
          </div>

          <div className="pt-8 border-t border-gray-200">
              <p className="text-sm font-medium text-gray-900 mb-2">
                Call office:
              </p>
              <Button
                onClick={handleCallOffice}
                variant="link"
                className="text-2xl font-black text-blue-600 p-0 h-auto"
              >
                01376 519743
              </Button>
            </div>
        </div>

        <DialogFooter>
          <Button onClick={handleClose} variant="outline" className="w-full">
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
